import { Box, Text, Grid, GridItem  } from "@chakra-ui/react";
import React from "react";
import Navbar from "../../components/Navbar";
import { theme } from "../../styles/theme";
import { Link } from 'react-router-dom';
import { BrandsCarousel } from '../../components/BrandsCarousel'
import beerImage from '../../assets/images/cervejas-img.png';
import wineImage from '../../assets/images/vinhos-img.png';
import spiritImage from '../../assets/images/destilados-img.png';
import readyToDrinkImage from '../../assets/images/drinks-img.png';
import bestSellingImage from '../../assets/images/vendidos-img.png';
import nonAlcoholicImage from '../../assets/images/non-alcoolicos-img.png';
import biggerDiscountImage from '../../assets/images/descontos-img.png';
import kitsImage from '../../assets/images/kits-img.png';
import newProductsImage from '../../assets/images/novidades-img.png';
import buffetsImage from '../../assets/images/eventos-img.png';
import brewersImage from '../../assets/images/microcervejaria-img.png';
import choppImage from '../../assets/images/chopp-img.png';

// const MemoizedNavbar = React.memo(Navbar);
export function Store() {
  const typesOfCardToSelec = [
    {
      cardTitle: "Chopp",
      param: JSON.stringify(["chopp", "Chopp"]),
      cardImageUrl: choppImage,

    },
    {
      cardTitle: "Drinks Prontos",
      param: JSON.stringify(["OUTRAS BEBIDAS", "BEBIDAS MISTAS"]),
      cardImageUrl: readyToDrinkImage,

    },
    {
      cardTitle: "Microcervejarias",
      param: JSON.stringify(["Microcervejarias", "microcervejarias", "microcervejaria", "Microcervejaria"]),
      cardImageUrl: brewersImage,

    },
    {
      cardTitle: "Cervejas",
      param: JSON.stringify(["CERVEJA", "Cerveja"]),
      cardImageUrl: beerImage,

    },
    {
      cardTitle: "Vinhos e Espumantes",
      param: JSON.stringify(["Vinho"]),
      cardImageUrl: wineImage,

    },
    {
      cardTitle: "Destilados",
      param: JSON.stringify(["DESTILADOS"]),
      cardImageUrl: spiritImage,

    },
    {
      cardTitle: "Eventos, Buffets e Casamentos",
      param: JSON.stringify(["Eventos, Buffets e Casamentos"]),
      cardImageUrl: buffetsImage,

    },
    {
      cardTitle: "KITS",
      param: JSON.stringify(["Kits"]),
      cardImageUrl: kitsImage,

    },
    {
      cardTitle: "Não Alcoólicos",
      param: JSON.stringify(["NÃO ALCOOLICOS", "Não alcoólicos", "Não Alcoólicos", "NÃO ALCOOLICO", "Não alcóolico", "Não Alcóolico"]),
      cardImageUrl: nonAlcoholicImage,

    },
    {
      cardTitle: "Novidades",
      param: JSON.stringify(["Novidades"]),
      cardImageUrl: newProductsImage,

    },
    {
      cardTitle: "Mais Vendidos",
      param: JSON.stringify(["Mais Vendidos"]),
      cardImageUrl: bestSellingImage,

    },
    {
      cardTitle: "Maiores Descontos",
      param: JSON.stringify(["Maiores Descontos"]),
      cardImageUrl: biggerDiscountImage,

    }
  ];

  return (
    <Box
      maxW="1400px"
      mx="auto"
      px={{ base: "16px", md: "32px" }}
      py={{ base: "0", md: "0" }}
    >
      {/* Section header */}
      <Box mb={{ base: "28px", md: "48px" }}>
        <Text
          fontSize="11px"
          fontWeight="800"
          color="#fc8f04"
          textTransform="uppercase"
          letterSpacing="0.14em"
          mb="10px"
        >
          Catálogo
        </Text>
        <Text
          fontSize={{ base: "26px", md: "38px" }}
          fontWeight="900"
          color={theme.colors.primaryGreen}
          letterSpacing="-0.03em"
          lineHeight="1.1"
          mb="8px"
        >
          Explore por categoria
        </Text>
        <Text fontSize={{ base: "14px", md: "15px" }} color="gray.500" fontWeight="500">
          Encontre exatamente o que você procura
        </Text>
      </Box>
      <Grid
        templateColumns={{
          base: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
          lg: "repeat(4, 1fr)",
          xl: "repeat(6, 1fr)"
        }}
        gap={{ base: 4, md: 6 }}
      >
        {typesOfCardToSelec.map((card, index) => (
          <Link
            to={`/produtos?filter=${encodeURIComponent(card.param)}`}
            key={index}
          >
            <Box
              role="group"
              overflow="hidden"
              borderRadius="24px"
              bg="white"
              boxShadow="
                0 8px 24px rgba(0,74,51,.06),
                0 2px 6px rgba(0,0,0,.04)
              "
              transition="all .25s ease"
              _hover={{
                transform: {
                  base: "none",
                  md: "translateY(-6px)"
                },
                boxShadow: "0 16px 40px rgba(0,74,51,.16)"
              }}
            >
              <Box
                position="relative"
                sx={{ aspectRatio: "1.7" }}
                bg="white"
                overflow="hidden"
              >
                <Box
                  as="img"
                  src={card.cardImageUrl}
                  w="100%"
                  h="100%"
                  objectFit="contain"
                  p={{ base: 2, md: 3 }}
                />
              </Box>
            </Box>
          </Link>
        ))}
      </Grid>

      <Box mt={{ base: "32px", md: "56px" }} mb={{ base: "24px", md: "32px" }}>
        <Box w="36px" h="3px" bg="#fc8f04" borderRadius="99px" mb="10px" />
        <Text
          fontSize={{ base: "26px", md: "36px" }}
          fontWeight="900"
          color={theme.colors.primaryGreen}
          letterSpacing="-0.03em"
          lineHeight="1.1"
          mb="6px"
        >
          Grandes Marcas
        </Text>
        <Text fontSize={{ base: "14px", md: "15px" }} color="gray.500" fontWeight="500">
          As marcas que fazem a diferença no seu copo
        </Text>
      </Box>
      <BrandsCarousel />
    </Box>
  )
}
